import type { CameraGraph } from '@toolproof-core/visualization/_contract/camera';

import { resolveEpisodeCameraView } from '@/_pure/episodeCamera';
import { toPrimitiveCameraViewId } from '@/adapters/primitive/_pure/derivation/cameraGraph';

export function resolvePrimitivePresentationCameraView(
    cameraView: string | undefined, scope: string, graph: CameraGraph,
): string | undefined {
    return resolveEpisodeCameraView(cameraView, {
        viewId: view => view === 'overview' ? 'overview' : toPrimitiveCameraViewId(scope, view),
        hasView: view => graph.views[view] !== undefined,
    });
}
